<template>
    <div class="seomain">
        <div class="tab-content">
            <div class="st-list-box pan-105">
                <div class="st-list" v-for="(v,k) in stlist" :key="k" :index="k">
                    <div class="st-list-top">
                        <div class="t-tit">{{ v.code }}</div>
                        <div
                            class="t-check-btn"
                            :class="v.quality > 0 ? 'on' : 'off'"
                            @click="show_check_box(v.purchase_products_id)"
                        >{{ v.qualityname }}</div>
                    </div>
                    <div class="st-list-main">
                        <p>SKU：{{ v.sku }}</p>
                        <p>品类：{{ v.cname }}</p>
                        <p>品牌：{{ v.brand }}</p>
                        <p>型号：{{ v.model }}</p>
                        <p>配置：{{ v.deploy }}</p>
                        <p>已入库：{{ v.storageed }}</p>
                        <p class="red bold">待入库：{{ v.storageing }}</p>
                        <p>备注：{{ v.remark }}</p>
                    </div>
                    <div
                        class="st-list-bottom"
                        @click="show_detail_box(v.purchase_products_id)"
                        v-if="flag != 'false'"
                    >
                        <p class="st-opt-btn">操 作</p>
                    </div>
                </div>
            </div>
        </div>

        <van-dialog v-model="show" show-cancel-button @confirm="edit_st2()">
            <div class="mix-detail-box">
                <h2>SKU：{{ oneinfo.sku }}</h2>
                <p>品类：{{ oneinfo.cname }}</p>
                <p>品牌：{{ oneinfo.brand }}</p>
                <p>型号：{{ oneinfo.model }}</p>
                <p>配置：{{ oneinfo.deploy }}</p>
                <p>已入库：{{ oneinfo.storageed }}</p>
                <p class="red bold">待入库：{{ oneinfo.storageing }}</p>
                <p class="input-item">
                    <span>入库数量：</span>
                    <el-input class="input" v-model="dialog_num" placeholder="请输入入库数量"></el-input>
                </p>
                <p class="input-item">
                    <span>异常数量：</span>
                    <el-input class="input" v-model="dialog_num1" placeholder="请输入异常数量"></el-input>
                </p>
            </div>
        </van-dialog>
        <van-dialog v-model="show_quality" show-cancel-button @confirm="edit_st2_check()">
            <div class="mix-detail-box">
                <h2>确认质检</h2>
            </div>
        </van-dialog>
    </div>
</template>

<script>
export default {
    components: {},
    props: {},
    data() {
        return {
            dialog_num: '',
            dialog_num1: '',
            show: !1,
            show_quality: !1,
            stlist: [],
            stinfo: {},
            oneinfo: {},
            paramsid: 0,
            activeid: 0,
            checkid: 0,
        };
    },
    watch: {},
    computed: {
        flag() {
            return this.$route.params.flag;
        }
    },
    methods: {
        edit_st2: function() {
            let t = this;
            if (this.$isEmpty(this.dialog_num)) {
                return this.$message.error('请先填写内容');
            } else {
                t.edit_st();
            }
        },
        edit_st: function() {
            var ss = { id: this.activeid, stnum: this.dialog_num, loss: this.dialog_num1 };
            this.$post(this.$api.stGetCaigouEdit, ss).then(res => {
                if (res.code == 200) {
                    this.$message.success('修改成功');
                    this.get_caigou_info();
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        edit_st2_check: function() {
            this.$post(this.$api.stGetCaigouCheck, { id: this.checkid }).then(res => {
                if (res.code == 200) {
                    this.$message.success('修改成功');
                    this.get_caigou_info();
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        show_check_box: function(e) {
            var c;
            this.$post(this.$api.stGetCaigouView, { id: e }).then(res => {
                c = res.data.quality;
                if (c > 0) {
                    this.$toast.success('已质检');
                } else {
                    this.show_quality = !0;
                }
                this.checkid = res.data.purchase_products_id;
            });
        },
        show_detail_box: function(e) {
            this.$post(this.$api.stGetCaigouView, { id: e }).then(res => {
                this.oneinfo = res.data;
                this.activeid = res.data.purchase_products_id;
                console.log(this.activeid);
                this.show = !0;
            });
        },
        get_caigou_info: function() {
            let paramsid = this.$route.params.id;
            this.$post(this.$api.stGetCaigouInfo, { id: paramsid }).then(res => {
                this.stlist = res.data;
            });
        },
    },
    created() {
        this.get_caigou_info();
        window.h5sdk.ready(function() {
            window.h5sdk.biz.navigation.setTitle({ title: '采购价格维护' });
        })
    },
    mounted() {
    }
};
</script>
<style lang="scss" scoped>
.st-list-top .t-tit {
    height: 20px;
    line-height: 20px;
    margin-top: 8px;
}
.st-list-top .t-check-btn {
    padding: 6px 10px;
    border-radius: 10px;
    color: #fff;
}
.st-list-top .off {
    background: #00baad;
}
.st-list-top .on {
    background: #51596e;
}
.input-item {
    display: flex;
}
.input-item span {
    display: inline-block;
}
.input-item .input {
    flex: 1;
}
</style>